package com.gavino.nutritrack

import kotlin.js.Date

actual fun getTodayDateLabel(): String {
    val d = Date()
    val day = d.getDate().toString().padStart(2, '0')
    val month = (d.getMonth() + 1).toString().padStart(2, '0')
    return "$day/$month"
}

actual fun getRelativeDateLabel(offsetDays: Int): String {
    val d = Date(Date.now() + offsetDays * 86400000.0)
    val day = d.getDate().toString().padStart(2, '0')
    val month = (d.getMonth() + 1).toString().padStart(2, '0')
    return "$day/$month"
}

actual fun getCurrentWeekKey(): String {
    val d = Date()
    val fullYear = d.getFullYear()
    val dayOfWeek = (d.getDay() + 6) % 7
    val monday = Date(d.getTime() - dayOfWeek * 86400000.0)
    val mDay = monday.getDate().toString().padStart(2, '0')
    val mMonth = (monday.getMonth() + 1).toString().padStart(2, '0')
    return "$fullYear-W$mMonth-$mDay"
}
